/*
 * @Autor: 周烨
 * @Date: 2021-06-15 09:59:00
 * @Description: 
 * @LastEditors: 周烨
 * @LastEditTime: 2021-08-06 15:21:57
 * @FilePath: \aodian\src\router.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from "./store";

import Sbwx from "./views/Sbgl.vue"

Vue.use(Router)
const router = new Router({
    routes: [
        {
            path: '/',
            name: 'layout',
            redirect: '/about',
            component: () => import('./views/Layout.vue'),
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: () => import('./views/Home.vue')
                },
                {
                    path: '/about',
                    name: 'about',
                    component: () => import('./views/About.vue')
                },
                {
                    path: '/privacy-policy',
                    name: 'privacy-policy',
                    component: () => import('./views/privacy-policy.vue')
                },
                {
                    path: '/product',
                    name: 'product',
                    component: () => import('./views/Product.vue'),
                    children: [
                        {
                            path: 'list',
                            component: () => import('./views/product/list.vue'),
                            name: 'productList'
                        },
                        {
                            path: 'edit',
                            component: () => import('./views/product/edit.vue'),
                            name: 'productEdit'
                        }
                    ]
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue')
        },
        {
            path: '*',
            redirect: '/home'
        },
        {
            path: '/sbgl',
            name: 'sbgl',
            component: Sbwx
        },
        {
            path: '/pacs',
            name: 'pacs',
            component: () => import('./views/Pacs.vue')
        },
        {
            path: '/snzk',
            name: 'snzk',
            component: () => import('./views/Snzk.vue')
        },
        {
            path: '/hcgl',
            name: 'hcgl',
            component: () => import('./views/Hcgl.vue')
        },
        {
            path: '/ydcx',
            name: 'ydcx',
            component: () => import('./views/Ydcx.vue')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router
